module.exports = __webpack_public_path__ + "static/media/bursts_28.e84946f4.svg";